import React, { useMemo } from 'react';
import { AudioElement } from '@bynder-studio/render-core';
import useEditorSelectedElement from '~/hooks/useEditorSelectedElement';
import Shots from './Shots';
import Globals from './Globals';
import generateTestId from '~/helpers/testIdHelpers';

const testId = generateTestId('editor_sidebar');

const RightSideMenu = () => {
    const { selectedElement, selectedElements, topLevelSelectedElements } = useEditorSelectedElement();

    const isMultiSelection = useMemo(() => topLevelSelectedElements?.length > 1, [topLevelSelectedElements]);

    const isMultiSelectionOfAudio = useMemo(
        () => isMultiSelection && topLevelSelectedElements.filter((el) => !(el instanceof AudioElement)).length === 0,
        [isMultiSelection, topLevelSelectedElements],
    );

    return (
        <div {...testId}>
            {selectedElement || isMultiSelection ? (
                <Shots
                    isMultiSelectionOfAudio={isMultiSelectionOfAudio}
                    isMultiSelection={isMultiSelection}
                    selectedElement={selectedElement}
                    selectedElements={selectedElements}
                />
            ) : (
                <Globals />
            )}
        </div>
    );
};

export default RightSideMenu;
